export const STORE_PROJECT_FORM_TYPES = 'projectFormTypesUI';
export type STORE_PROJECT_FORM_TYPES = typeof STORE_PROJECT_FORM_TYPES;

export const STORE_PROJECT_FORM_TYPES_VISUAL = 'projectFormTypesVisualUI';
export type STORE_PROJECT_FORM_TYPES_VISUAL = typeof STORE_PROJECT_FORM_TYPES_VISUAL;

export const STORE_PROJECT_FORM_PART_PREVIEW = 'projectFormPartPreviewUI';
export type STORE_PROJECT_FORM_PART_PREVIEW = typeof STORE_PROJECT_FORM_PART_PREVIEW;
